import { useEffect, memo, useState, useRef } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import { Row, Col, Select, Modal } from "antd";
import styled from "styled-components";
import moment from "moment";
import {
  IAmphur,
  IResultUpdate,
  ITrashfeeArea,
  ITrashfeeAreaCreate,
  ITrashfeeAreaDetailForm,
  ItrashfeeAreaUpdate,
  ITrashfeeDistrict,
} from "@interfaces";
import { StyledSubmitButton, StyledCancelButton, StyledCard, SharedInput } from "@components";
import { useYup } from "@validations";
import { setLoading, selectAuth, selectContact } from "@redux";
import { showErrorMessage, useNotify } from "@utils";
import { PATH_TRASH_FEE_AREA, PATH_TRASH_FEE_AREA_CREATE } from "@configs";
import { trashfeeAPI } from "@api";

interface IProps {
  // result: IResult | undefined;
  detail: ITrashfeeArea | undefined;
  // districtList: ITrashfeeDistrict[];
}

const initData: IResultUpdate = {
  organization_id: "",
  title: "",
  image_url: "",
  is_enable: true,
  information_id: "",
  created_date: new Date().toString(),
  documents: [],
};
const { Option } = Select;
export const ModuleAreaForm = memo((props: IProps) => {
  //hook
  const { YupNews, YupBidding } = useYup();

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams<{ id: string }>();
  const { error, success } = useNotify();
  const search_params = useSelector(selectContact).paramsContact;
  const org_id = useSelector(selectAuth).auth?.organization_data?._id;


  const organization_id = useSelector(selectAuth).auth?.admin_data?.organization_id;

  const pathName = window.location.pathname;

  const createBidding = Yup.object().shape(YupBidding);
  const { detail } = props;
  const [amphurList, setAmphurList] = useState<IAmphur[]>([]);
  const [districtList, setDistrictList] = useState<ITrashfeeDistrict[]>([]);
  const [focusAmphur, setFocusAmphur] = useState<string>("");
  const [value, setValue] = useState<ITrashfeeAreaDetailForm>({
    organization_id: "",
    area_id: "",
    area_name: "",
    street: "",
    village: "",
    soi: "",
    zipcode: "",
    district_id: "",
    district_code: "",
    district_name: "",
    amphur_id: "",
  });

  useEffect(() => {
    if (org_id) {
      getAllAmphur();
    }
  }, [org_id]);

  useEffect(() => {
    if (focusAmphur !== "") {
      fetchDistrict(focusAmphur);
    }
  }, [focusAmphur]);

  useEffect(() => {
    if (detail) {
      console.log('detail', detail);
      let raw = {
        ...value,
        organization_id: organization_id || "",
        area_id: detail._id,
        area_name: detail.area_name,
        street: detail.street,
        village: detail.area_name,
        soi: detail.soi,
        zipcode: detail.zipcode,
        district_id: detail.district_id,
        amphur_id: detail.amphur_id,
        ...(detail.amphur_id === "" && {
          district_id: "",
          amphur_id: "",
        }),
      };
      console.log('raw ', raw);
      setValue(raw);
    }
  }, [detail]);

  const fetchDistrict = async (aId: string) => {
    try {
      const response = await trashfeeAPI.getDistrictList({
        amphur_id: aId,
        xpage: 1,
        xlimit: 30,
      });
      console.log(response.data.result);
      setDistrictList(response.data.result);
    } catch (err: any) {
      error(err.message);
    }
  };

  const getAllAmphur = async () => {
    try {
      let response = await trashfeeAPI.getAllAmphurByOrganizationId({
        organization_id: org_id || ""
      });
      if (response.data.error === "0") {
        setAmphurList(response.data.result);
      } else {
        error(response.data.msg);
      }
    } catch (error: any) {
      if (error) {
        error(error.msg);
      }
    }
  };
  const handleBiddingSubmit = (values: IResultUpdate) => {
    console.log("hello submit", values);
  };

  const handleClose = () => {
    history.push(PATH_TRASH_FEE_AREA);
  };

  const changeField = (e: any) => {
    let arr = value;
    arr[e.target.id] = e.target.value;
    setValue({ ...arr });
  };

  const { values, handleChange, handleBlur, handleSubmit, errors, touched, setFieldValue } =
    useFormik({
      initialValues: initData,
      validationSchema: createBidding,
      enableReinitialize: true,
      onSubmit: handleBiddingSubmit,
    });

  const saveArea = async () => {
    dispatch(setLoading(true));
    if (pathName === PATH_TRASH_FEE_AREA_CREATE) {
      try {
        let payload: ITrashfeeAreaCreate = {
          organization_id: organization_id || "",
          area_name: value.area_name,
          village: value.area_name,
          street: value.street,
          soi: value.soi,
          district_id: value.district_id,
          amphur_id: value.amphur_id,
        };
        await trashfeeAPI.createArea(payload);
        success(t("message.create.success"));
        dispatch(setLoading(false));
        handleClose();

      } catch (err: any) {
        if (err.response) {
          err(showErrorMessage(err.response));
        } else {
          error(t("message.error"));

        }
        dispatch(setLoading(false));
      }
    } else {
      try {
        let payload: ItrashfeeAreaUpdate = {
          organization_id: organization_id || "",
          area_id: value.area_id,
          village: value.area_name,
          area_name: value.area_name,
          street: value.street,
          soi: value.soi,
          district_id: value.district_id,
          amphur_id: value.amphur_id
        };
        await trashfeeAPI.updateArea(payload);
        success(t("message.create.success"));
        dispatch(setLoading(false));
        handleClose();
      } catch (err: any) {
        if (err.response) {
          err(showErrorMessage(err.response));
        } else {
          error(t("message.error"));
        }
        dispatch(setLoading(false));
      }
    }
  };


  const districtChange = (id: string) => {
    setValue({
      ...value,
      district_id: id,
    });
  };
  const amphurChange = (id: string) => {
    setValue({
      ...value,
      amphur_id: id,
      district_id: "",
    });
    setFocusAmphur(id);
  };

  return (
    <div className="form-wrap">
      <form onSubmit={handleSubmit}>
        <div className="page-header">
          <h3>
            {pathName === PATH_TRASH_FEE_AREA_CREATE
              ? "เพิ่มหมวดพื้นที่"
              : "แก้ไขหมวดพื้นที่"
            }
          </h3>
          <p>โปรดระบุรายละเอียดให้ครบถ้วน</p>
        </div>
        {/* สร้างรายการประกาศผล */}
        {pathName === PATH_TRASH_FEE_AREA_CREATE ? (
          <StyledPageBody>
            <StyledCard>
              <div className="title">
                ข้อมูลหมวดพื้นที่
              </div>
              <div>
                <Row gutter={16}>
                  <Col xs={12} sm={12} md={24}>
                    <SharedInput
                      label="ชื่อหมวดพื้นที่*"
                      // descLabel={t("page._2_100_characters")}
                      name="area_name"
                      onBlur={handleBlur}
                      onChange={changeField}
                      value={value.area_name}
                      parentClassName="mb-6"
                    />
                  </Col>
                  <Col xs={6} sm={6} md={12}>
                    <SharedInput
                      label="ซอย"
                      // descLabel={t("page._2_100_characters")}
                      name="soi"
                      onBlur={handleBlur}
                      onChange={changeField}
                      value={value.soi}
                      parentClassName="mb-6"
                    />
                  </Col>
                  <Col xs={6} sm={6} md={12}>
                    <SharedInput
                      label="ถนน"
                      // descLabel={t("page._2_100_characters")}
                      name="street"
                      onBlur={handleBlur}
                      onChange={changeField}
                      value={value.street}
                      parentClassName="mb-6"
                    />
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col xs={6} sm={6} md={12}>
                    <label className="label">
                      <span className="label-name">อำเภอ*</span>
                      <br /> <br />
                    </label>
                    <Select
                      value={value?.amphur_id}
                      onChange={amphurChange}
                    >
                      {amphurList.length > 0 &&
                        amphurList.map((item, index) => {
                          return (
                            <Option value={item.amphur_id} key={index}>
                              {item.amphur_name_tha}
                            </Option>
                          );
                        })
                      }
                    </Select>
                  </Col>
                  <Col xs={6} sm={6} md={12}>
                    <label className="label">
                      <span className="label-name">ตำบล*</span>
                      <br /> <br />
                    </label>
                    <Select
                      value={value.district_id}
                      onChange={districtChange}
                    >
                      {districtList.length > 0 &&
                        districtList.map((item, index) => {
                          return (
                            <Option value={item.district_id} key={index}>
                              {item.district_name_tha}
                            </Option>
                          );
                        })
                      }
                    </Select>
                  </Col>
                </Row>
              </div>
            </StyledCard>
            <div className="btn-layout">
              <StyledSubmitButton
                type="default"
                text={t("page.save")}
                // htmlType="submit"
                onClick={saveArea}
              // onClick={handleSubmit}
              />
              <StyledCancelButton
                type="sub"
                text={t("page.cancel")}
                htmlType="button"
                onClick={handleClose}
              />
            </div>
          </StyledPageBody>
        ) : (
          <StyledPageBody>
            <StyledCard>
              <div className="title">
                ข้อมูลหมวดพื้นที่
              </div>
              <div>
                <Row gutter={16}>
                  <Col xs={12} sm={12} md={24}>
                    <SharedInput
                      label="ชื่อหมวดพื้นที่*"
                      // descLabel={t("page._2_100_characters")}
                      name="area_name"
                      onBlur={handleBlur}
                      onChange={changeField}
                      value={value.area_name}
                      parentClassName="mb-6"
                    />
                  </Col>
                  <Col xs={6} sm={6} md={12}>
                    <SharedInput
                      label="ซอย"
                      // descLabel={t("page._2_100_characters")}
                      name="soi"
                      onBlur={handleBlur}
                      onChange={changeField}
                      value={value.soi}
                      parentClassName="mb-6"
                    />
                  </Col>
                  <Col xs={6} sm={6} md={12}>
                    <SharedInput
                      label="ถนน"
                      // descLabel={t("page._2_100_characters")}
                      name="sgreet"
                      onBlur={handleBlur}
                      onChange={changeField}
                      value={value.street}
                      parentClassName="mb-6"
                    />
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col xs={6} sm={6} md={12}>
                    <label className="label">
                      <span className="label-name">อำเภอ*</span>
                      <br /> <br />
                    </label>
                    <Select
                      value={value?.amphur_id}
                      onChange={amphurChange}
                    >
                      {amphurList.length > 0 &&
                        amphurList.map((item, index) => {
                          return (
                            <Option value={item.amphur_id} key={index}>
                              {item.amphur_name_tha}
                            </Option>
                          );
                        })
                      }
                    </Select>
                  </Col>
                  <Col xs={6} sm={6} md={12}>
                    <label className="label">
                      <span className="label-name">ตำบล*</span>
                      <br /> <br />
                    </label>
                    <Select
                      value={value.district_id}
                      onChange={districtChange}
                    >
                      {districtList.length > 0 &&
                        districtList.map((item, index) => {
                          return (
                            <Option value={item.district_id} key={index}>
                              {item.district_name_tha}
                            </Option>
                          );
                        })
                      }

                    </Select>
                  </Col>
                </Row>
              </div>
            </StyledCard>
            <div className="btn-layout">
              <StyledSubmitButton
                type="default"
                text={t("page.save")}
                // htmlType="submit"
                onClick={saveArea}
              // onClick={handleSubmit}
              />
              <StyledCancelButton
                type="sub"
                text={t("page.cancel")}
                htmlType="button"
                onClick={handleClose}
              />
            </div>
          </StyledPageBody>
        )}
      </form>
    </div>
  );
});
const StyledAddCategoryModal = styled(Modal)`
    .ant-modal-header {
        border-bottom: 0.5px solid #8a959e !important;
        margin-bottom: 20px;
    }
    .form-input {
        .input-with-search {
            width: 100%;
        }
        .ant-select-selection__rendered {
            height: 100%;
        }
    }
    .footer {
        display: flex;
        justify-content: center;
        .add-cat-btn {
            width: 170px;
        }
    }
`;
const StyledSwitch = styled.div`
    display: flex;
    align-items: center;
    p {
        margin-bottom: 0;
    }
`;

const StyleMenuTab = styled.div`
    span {
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        margin-right: 10px;
        padding: 10px;
        cursor: pointer;
    }
    .selected {
        background-color: #fff;
        border-top: 5px solid #0d6efd;
        color: #0d6efd;
        border-radius: 5px 5px 0 0;
    }
`;

const StyledBidderNum = styled.div`
    height: 30px;
    display: flex;
    .title {
        margin-left: 5px;
    }

    .number {
        font-weight: 600;
        font-size: 35px;
        line-height: 53px;
        margin-left: auto;
    }
`;

const StyledBidderList = styled.div`
    .header {
        display: flex;
        justify-content: space-between;
    }
`;

const StyledPageBody = styled.div`
    display: grid;
    /* grid-template-columns: 760px 2fr; */
    grid-gap: 15px;
`;

const StyledDetailBody = styled.div`
    background: #ffffff;
    border-radius: 4px;
    padding: 30px;
    max-width: 700px;
    .title {
        font-weight: 500;
        font-size: 25px;
        line-height: 38px;
    }
    .period {
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
    }

    hr {
        border-top: 1px solid #f3f3f3;
    }

    .detail-headline {
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
    }
    .detail-desc {
        font-weight: 300;
        font-size: 16px;
        line-height: 24px;
    }
`;

const StyledDocument = styled.div`
    background-color: #f4f4f4;
    border-radius: 5px;
    margin: 10px 0px;
    display: flex;
    justify-content: space-between;
    .name {
        margin: auto 30px;
        font-weight: 600;
    }
    button {
        background-color: #0d6efd;
        border: none;
        padding: 10px;
        width: 100px;
        border-radius: 5px;
        color: white;
        margin: 15px;
    }
`;

const StyledFileName = styled.p`
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
`;
